import { getSessionStorage } from '../../utils/sessionStorage'
import { SearchState } from '@/types/models'
import { isNil } from '../../utils/checks'
import normalizeSearchState from './normalizeSearchState'
import refineSearchStateByRemovingLocationsAndGeoLoc from './refineSearchStateByRemovingLocationsAndGeoLoc'
interface ClearAllRefinementsFromSearchState {
  (taxonomy: string): Partial<SearchState>
}

const clearAllRefinementsFromSearchState: ClearAllRefinementsFromSearchState =
  () => {
    return normalizeSearchState({
      ...refineSearchStateByRemovingLocationsAndGeoLoc(),
      refinementList: {}
    })
  }

export default clearAllRefinementsFromSearchState
